<sam4-first-page-layout>
  @if (error$ | async; as error) {
    <h1 class="text-warning">AI-Media authorization error</h1>
    <p class="text-warning text-center">Reason: {{error.message}}</p>
    <a class="link-primary" routerLink="/">Back to the login page</a>
  } @else {
    Authorization in progress ...
  }
</sam4-first-page-layout>

